import { render, staticRenderFns } from "./SkupKotizacijaEdit.vue?vue&type=template&id=9915afbc&scoped=true&"
import script from "./SkupKotizacijaEdit.vue?vue&type=script&lang=js&"
export * from "./SkupKotizacijaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9915afbc",
  null
  
)

export default component.exports